import { CheckCircleOutlined } from '@ant-design/icons'
import { StepProps } from '@components/connectors/types'
import { Button, Result } from 'antd'
import { Link } from 'react-router-dom'
import { ContentWrapper } from './ContentWrapper'

export const TestIntegration = ({ venue, onPrev }: StepProps) => {
  return (
    <ContentWrapper>
      <Result
        icon={<CheckCircleOutlined />}
        title="Your booking connector has been successfully configured."
        subTitle={`You can now test the configuration for ${venue.name} in real time
            using the Availability Viewer to verify that your venue’s
            availability data is correctly synced with Sevenrooms.`}
        extra={[
          <Button loading={false} onClick={onPrev}>
            Previous
          </Button>,
          <Link target="blank" to={'/settings/booking/availability-viewer'}>
            <Button type="primary" variant={'outlined'}>
              Test configuration
            </Button>
          </Link>,
        ]}
      />
    </ContentWrapper>
  )
}
